import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'
import { HttpMethod } from '../../../services/core'

const resource = 'offers'
const verb = HttpMethod.DELETE

export default class OspreyOffersRemoveFromSilosShare extends BaseAction {
    constructor(dataKey) {
        const id = '97e525e6-8703-40f6-bb69-00ac6825e99a'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    removeFromSilosShare(params) {
        const { offerId, siloIdList } = params

        this.path = `/${resource}/${offerId}/share/silos`

        this.params = {
            siloIdList
        }

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-silos-remove.js